import { Card } from "../shared/Card";
import { GameRouteService } from "./GameRouteService";

/** Implements the rules and mechanics of the Blackjack game */
export class BlackjackService extends Card {
    private readonly gameRouteService: GameRouteService = new GameRouteService();
    public dealerScore: number = 0;
    public playerScore: number = 0;
    public dealerDrawnCards: string[] = [];
    public playerDrawnCards: string[] = [];

    public constructor() {
        super();
    }

    public dealCard(): string {
        return this.deck.pop()!;
    }

    /** Deals the dealers card */
    public playDealerTurn(): string[] {
        while (this.dealerScore < 17) {
            const card: string = this.dealCard();
            this.dealerScore += this.getValue(card, this.dealerScore);
            this.dealerDrawnCards.push(card);
        }

        return this.dealerDrawnCards;
    }

    /** Shows the 2 cards of the player */
    public playPlayerTurn(): string[] {
        for (let i: number = 0; i < 2; i++) {
            this.addCardToPlayer();
        }

        return this.playerDrawnCards;
    }

    /** Deals card to player */
    public addCardToPlayer(): string {
        const card: string = this.dealCard();
        this.playerScore += this.getValue(card, this.playerScore);
        this.playerDrawnCards.push(card);

        return card;
    }

    /** Deals the hidden card to the dealer and updates their score. */
    public dealHiddenCard(): string {
        const card: string = this.dealCard();
        this.dealerScore += this.getValue(card, this.dealerScore);

        return card;
    }

    /** Shows the result of the blackjack game */
    public async result(): Promise<string> {
        switch (true) {
            case (this.playerScore > 21):
                await this.gameRouteService.getBlackjackStatusLose();
                return "Dealer: Haha, you busted! Better luck next time!";

            case (this.dealerScore > 21):
                await this.gameRouteService.getBlackjackStatusWin();
                return "Dealer: Oops, I busted! You win!";

            case (this.playerScore === this.dealerScore):
                await this.gameRouteService.getBlackjackStatusLose();
                return "Dealer: Well well, it's a tie! But since I'm the dealer, I'll call it a win for me. Better luck next time!";

            case (this.playerScore > this.dealerScore):
                await this.gameRouteService.getBlackjackStatusWin();
                return "Dealer: Ugh, you got lucky... Must’ve been a glitch in the cards! Enjoy it while it lasts!";

            case (this.playerScore < this.dealerScore):
                await this.gameRouteService.getBlackjackStatusLose();
                return "Dealer: Haha, another win for the house! I’d feel bad for you… but I don’t!";

            default:
                return "";
        }
    }
}
